import React from 'react'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import OGSidebar from '@components/Details/Sidebar'

const Sidebar = () => {
  const {
    setInfoSlideOutOpen,
    auction,
    itemState: { id: itemId, itemClosed },
    pageNumber,
  } = useItemPage()

  const {
    auctionNumber,
    title,
    location: { address, city, state, zip },
    utcEndDateTime,
    auctionPickupDates,
    endTimeText,
  } = auction
  return (
    <aside className={'sticky top-30 self-start hidden md:block'}>
      <OGSidebar
        title={title}
        auctionNumber={auctionNumber}
        auction={auction}
        address={address}
        city={city}
        state={state}
        zip={zip}
        pageNumber={pageNumber}
        utcEndDateTime={utcEndDateTime}
        itemClosed={itemClosed}
        auctionPickupDates={auctionPickupDates}
        setInfoSlideOutOpen={setInfoSlideOutOpen}
        itemId={itemId}
        endTimeText={endTimeText}
        showBackButton
      />
    </aside>
  )
}

export default Sidebar
